import React from 'react';

const Card = ({ children, className = '', style }: { children: React.ReactNode; className?: string; style?: React.CSSProperties }) => {
  return (
    <div className={['bg-white dark:bg-gray-800 rounded-lg border border-gray-100 dark:border-gray-700', className].join(' ')} style={style}>
      {children}
    </div>
  );
};

export default Card;

